<div class="d-flex">
  <div class="tb-padding--right mr-4">
    <div class="form-group">
      <!-- <span class="mr-4 filter-title">{{titleStart || 'Từ ngày'}}</span> -->
      <div class="d-flex align-items-center">
        <div id="start-date" class="input-group d-flex flex-column ">
          <form class="start-date" [formGroup]="formDate">
            <div class="input-group">
              <input-date formControlName="startDate" [isNoFuture]="true"
                [placeholder]="'Từ ngày: dd/mm/yyyy'" [isNoInput]="true">
              </input-date>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
  <div class="tb-padding--right tb-padding--left">
    <div class="form-group">
      <!-- <span class="mr-3 filter-title">{{titleEnd || 'Đến ngày'}}</span> -->
      <div class="d-flex align-items-center">
        <div id="end-date" class="input-group d-flex flex-column">
          <form class="end-date" [formGroup]="formDate">
            <div class="input-group">
              <input-date formControlName="endDate" [isNoFuture]="true"
              [placeholder]="'Đến ngày: dd/mm/yyyy'" [isNoInput]="true">
            </input-date>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</div>